let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8zBSN")).then(() => parcelRequire('8TqBH'));